/**
 * Date formatting utilities for the podcast application
 * All dates in the UI should use the format: dd-Mmm-yyyy (e.g., 05-Jan-2026)
 */

/**
 * Format a date to dd-Mmm-yyyy format
 * @param {Date|string|number} date - Date object, ISO string, or timestamp
 * @returns {string} Formatted date string (e.g., "05-Jan-2026")
 */
export const formatDate = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const day = String(d.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[d.getMonth()];
  const year = d.getFullYear();
  
  return `${day}-${month}-${year}`;
};

/**
 * Format a date with time to dd-Mmm-yyyy HH:mm format
 * @param {Date|string|number} date - Date object, ISO string, or timestamp
 * @returns {string} Formatted date and time string (e.g., "05-Jan-2026 14:30")
 */
export const formatDateTime = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const day = String(d.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[d.getMonth()];
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  
  return `${day}-${month}-${year} ${hours}:${minutes}`;
};

/**
 * Format time only to HH:mm format
 * @param {Date|string|number} date - Date object, ISO string, or timestamp
 * @returns {string} Formatted time string (e.g., "14:30")
 */
export const formatTime = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  
  return `${hours}:${minutes}`;
};
